import { render, staticRenderFns } from "./3cxLicenses.vue?vue&type=template&id=4b5d24ae&scoped=true&"
import script from "./3cxLicenses.vue?vue&type=script&lang=js&"
export * from "./3cxLicenses.vue?vue&type=script&lang=js&"
import style0 from "./3cxLicenses.vue?vue&type=style&index=0&id=4b5d24ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5d24ae",
  null
  
)

/* custom blocks */
import block0 from "./3cxLicenses.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports